export default {"small-header-on-mobile":"_4hl2S","no-padding":"RM5cO"};